module.exports = __webpack_public_path__ + "static/img/date-range.21c0ab78.svg";